class SideDrawer extends HTMLElement {
  constructor() {
    super();

    const thisElement = this;

    //Toggle event listeners
    this.addEventListener("drawer-toggle", function () {
      if (this.classList.contains("active")) {
        thisElement.close(this);
      } else {
        thisElement.open(this);
      }
    });

    //Key up and body click events
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    //set drawer height
    this.drawerHeight();

    //add event listener for resize
    window.addEventListener("resize", this.drawerHeight);
  }

  //Open drawer
  open(drawer) {
    this.classList.add("active");
    document.body.classList.add("shadow");
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = "fixed";

    this.addEventListener(
      "transitionend",
      () => {
        drawer.focus();
        trapFocus(drawer);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });
  }

  //Close drawer
  close() {
    this.classList.remove("active");

    const activeDrawers = document.querySelectorAll("side-drawer.active");
    if (!activeDrawers.length) {
      document.body.classList.remove("shadow");
      const scrollY = document.body.style.top;
      document.body.style.top = "";
      document.body.style.position = "";
      window.scrollTo(0, parseInt(scrollY || 0) * -1);
      document.body.removeEventListener("click", this.onBodyClick, {
        passive: true,
      });
    }

    removeTrapFocus(this);
  }

  //Body click event to close drawer
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this &&
      !target.closest("side-drawer") &&
      !target.closest("side-drawer-toggle")
    ) {
      this.close();
    }
  }

  //recalculate height of drawer when viewport changes
  drawerHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }
}

customElements.define("side-drawer", SideDrawer);

class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", function (evt) {
      evt.preventDefault();

      if (this.getAttribute("data-drawer") == "all") {
        closeActiveDrawers();
      } else {
        if (this.classList.contains("drawers-close-active")) {
          closeActiveDrawers();
        }

        //get drawer element by ID from click event target data attribute
        const drawer = document.getElementById(
          this.getAttribute("data-drawer")
        );
        //dispatch event to trigger drawer state
        if (drawer) {
          drawer.dispatchEvent(new Event("drawer-toggle"));
        }
      }
    });

    function closeActiveDrawers() {
      const activeDrawers = document.querySelectorAll("side-drawer.active");
      if (!activeDrawers) return;

      activeDrawers.forEach((el) => {
        //Toggle drawer event
        el.dispatchEvent(new Event("drawer-toggle"));
      });
    }
  }
}

customElements.define("side-drawer-toggle", SideDrawerToggle);
